/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { contactValueLabelDtoSchema } from "./contactValueLabelDtoSchema";
import { z } from "zod/v4";

export const createContactDtoSchema = z.object({
    "firstName": z.optional(z.string()),
"lastName": z.optional(z.string()),
"fullName": z.optional(z.string()),
"preferredName": z.optional(z.string()),
"company": z.optional(z.string()),
"title": z.optional(z.string()),
"timezone": z.optional(z.string()),
"address": z.optional(z.string()),
"city": z.optional(z.string()),
"state": z.optional(z.string()),
"postalCode": z.optional(z.string()),
get "email"(){
                return z.array(contactValueLabelDtoSchema).optional()
              },
get "phone"(){
                return z.array(contactValueLabelDtoSchema).optional()
              },
get "links"(){
                return z.array(contactValueLabelDtoSchema).optional()
              }
    })